import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import StickyHeader from "@/components/StickyHeader";
import BottomNav from "@/components/BottomNav";
import Home from "@/pages/Home";
import Monumento from "@/pages/Monumento";
import Historia from "@/pages/Historia";
import Eventos from "@/pages/Eventos";
import Contacto from "@/pages/Contacto";
import Patrocinadores from "@/pages/Patrocinadores";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Move Emergent badge on mobile
const MoveEmergentBadge = () => {
  useEffect(() => {
    const moveBadge = () => {
      // Find the Emergent badge by its characteristics
      const allDivs = document.querySelectorAll('body > div');
      allDivs.forEach(div => {
        const style = div.getAttribute('style') || '';
        if (style.includes('position: fixed') && style.includes('bottom')) {
          const link = div.querySelector('a');
          if (link && (link.href?.includes('emergentagent') || link.textContent?.includes('Emergent'))) {
            // Move to top right on mobile
            if (window.innerWidth <= 768) {
              div.style.cssText = 'position: fixed !important; top: 75px !important; right: 10px !important; bottom: auto !important; left: auto !important; z-index: 30 !important; transform: scale(0.8) !important; transform-origin: top right !important;';
            }
          }
        }
      });
    };

    // Run immediately and on resize
    moveBadge();
    const interval = setInterval(moveBadge, 1000);
    window.addEventListener('resize', moveBadge);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', moveBadge);
    };
  }, []);

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <MoveEmergentBadge />
        <StickyHeader />
        <div className="page-wrapper">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/reloj-solar" element={<Monumento />} />
            <Route path="/nuestro-club" element={<Historia />} />
            <Route path="/eventos" element={<Eventos />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/patrocinadores" element={<Patrocinadores />} />
          </Routes>
        </div>
        <BottomNav />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
